(() => {
  'use strict';
  const config = document.getElementById('laboosh-wishlist-config');
  if (!config) return;
  const text = JSON.parse(config.textContent);
  let sdk;
  let pendingOpen;
  let localizedLayout;
  let controlsFrame;
  const savedVariants = new Set();
  window.SwymCallbacks = window.SwymCallbacks || [];
  if (Array.isArray(window.SwymCallbacks)) window.SwymCallbacks.unshift(() => preserveSyncedSizes());
  window.SwymCallbacks.push(swat => {
    sdk = swat;
    localizeWishlist();
    if (document.querySelector('#custom-wishlist-button, [data-product-wishlist]') && typeof swat.fetch === 'function') {
      swat.fetch(items => {
        (items || []).forEach(item => savedVariants.add(String(item.epi)));
        updateProductWishlistButton();
      });
    }
    const local = window.SwymLocalWishlist;
    // Consent can redirect to sign-in before the first sync finishes.
    // Resume unsynced items on the next storefront load.
    if (local && !local.isGhostIntentActive() && local.getSyncableItems().length) local.syncToCloud(swat);
  });

  function preserveSyncedSizes() {
    const local = window.SwymLocalWishlist;
    if (!local || local.labooshVariantSync) return;
    const originalSync = local.syncToCloud.bind(local);
    local.labooshVariantSync = true;
    local.syncToCloud = function(swat) {
      if (local.labooshSyncPending) return;
      const items = local.getSyncableItems().filter(item => item.epi && item.empi);
      if (!items.length) return originalSync(swat);
      local.labooshSyncPending = true;
      const api = swat.api;
      const call = (method, ...args) => new Promise((resolve, reject) => api[method](...args, resolve, reject));
      new Promise((resolve, reject) => api.fetchLists({ callbackFn: resolve, errorFn: reject }))
        .then(async lists => {
          const list = lists.find(item => !item.lty) || lists[0] || await call('createList', { lname: text.title });
          await call('addProductsToList', list.lid, items.map(({ epi, empi, du }) => ({ epi, empi, du: new URL(du, location.origin).href })));
          const saved = await call('fetchListCtx', { lid: list.lid });
          const confirmed = items.filter(item => saved.some(row => String(row.epi) === String(item.epi)));
          local.markItemsSynced(confirmed);
          if (confirmed.length !== items.length) throw new Error('Wishlist size sync not confirmed');
          originalSync(swat);
          window.SwymStorefrontLayoutExtensions?.refreshWishList?.();
        })
        .catch(() => {
          const header = document.querySelector('header-actions');
          if (header) message(header, text.failed);
        })
        .finally(() => { local.labooshSyncPending = false; });
    };
  }

  function localizeWishlist() {
    preserveSyncedSizes();
    const header = document.querySelector('header-actions');
    const icon = document.getElementById('swym-advanced-header-icon');
    if (header && icon && !header.contains(icon)) header.prepend(icon);
    if (icon) icon.setAttribute('aria-label', text.title);
    const data = document.getElementById('swym-ghost-wishlist-data');
    if (data && text.drawer) Object.entries(text.drawer).forEach(([key, value]) => data.setAttribute('data-' + key, value.replace('[count]', '{{count}}')));
    const popup = document.getElementById('swym-consent-popup');
    if (popup && text.consent) {
      Object.entries(text.consent.attributes).forEach(([key, value]) => popup.setAttribute('data-' + key, value.replace('[count]', '{{itemCount}}')));
      popup.querySelector('[data-swym-consent-close]')?.setAttribute('aria-label', text.drawer.close);
      if (!popup.dataset.labooshLocalized) {
        for (const [selector, value] of Object.entries(text.consent.labels)) {
          const element = popup.querySelector(selector);
          if (element) element.textContent = value;
        }
        popup.dataset.labooshLocalized = 'true';
      }
    }
  }
  document.addEventListener('DOMContentLoaded', localizeWishlist);
  window.addEventListener('load', localizeWishlist);
  function localizeAppControls() {
    const context = window.SwymStorefrontLayoutContext;
    const layout = window.SwymStorefrontLayoutExtensions?.SwymStorefrontLayout;
    if (layout && context?.Strings && text.cloud && localizedLayout !== layout && Object.entries(text.cloud).some(([key, value]) => context.Strings[key] !== value)) {
      localizedLayout = layout;
      const drawer = document.getElementById('swym-storefront-layout-container');
      const wasOpen = drawer && drawer.getAttribute('aria-hidden') !== 'true';
      Object.assign(context.Strings, text.cloud);
      layout.reRenderStorefrontLayoutUI();
      window.SwymStorefrontLayoutExtensions.refreshWishList();
      if (wasOpen) window.SwymStorefrontLayoutExtensions.SwymStorefrontLayout.open();
    }
    if (pendingOpen && (window.SwymStorefrontLayoutExtensions?.SwymStorefrontLayout || window.SwymGhostWishlistDrawer?.isActive())) {
      clearTimeout(pendingOpen);
      pendingOpen = null;
      openWishlist();
    }
    const icon = document.getElementById('swym-advanced-header-icon');
    if (icon && icon.getAttribute('aria-label') !== text.title) icon.setAttribute('aria-label', text.title);
    document.querySelectorAll('.laboosh-card-wishlist, #custom-wishlist-button').forEach(button => {
      const label = button.classList.contains('swym-added') ? text.remove : text.save;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    document.querySelectorAll('#swym-storefront-layout-container [aria-label="Close"]').forEach(button => {
      if (button.getAttribute('aria-label') !== text.drawer.close) {
        button.setAttribute('aria-label', text.drawer.close);
      }
    });
    updateProductWishlistButton();
  }
  function updateProductWishlistButton() {
    const root = document.querySelector('.laboosh-product');
    const button = root?.querySelector('[data-product-wishlist]');
    const heart = root?.querySelector('#custom-wishlist-button');
    if (!heart) return;
    const selected = root.querySelector('[data-inline-size].selected');
    const needsSize = root.querySelector('.laboosh-product__sizes') && !selected;
    const variant = String(selected?.dataset.variantId || heart.dataset.variantId);
    const size = selected?.dataset.sizeDisplay || '';
    const localItems = !sdk && window.SwymLocalWishlist?.getItems?.();
    const saved = localItems ? localItems.some(item => String(item.epi) === variant) : savedVariants.has(variant);
    const busy = heart.disabled;
    const label = needsSize ? text.choose : busy ? text.saving : saved ? text.saved.replace('[size]', size) : text.save;
    // Current product pages use an image heart without the older text button.
    // Keep both layouts in sync with the selected variant after page reload.
    if (button) {
      if (button.textContent !== label) button.textContent = label;
      button.disabled = busy;
      button.setAttribute('aria-busy', String(busy));
      button.setAttribute('aria-pressed', String(!needsSize && saved));
    }
    const isSaved = !needsSize && saved;
    heart.classList.toggle('swym-added', isSaved);
    heart.setAttribute('aria-pressed', String(isSaved));
    const heartLabel = isSaved ? text.remove : text.save;
    if (heart.getAttribute('aria-label') !== heartLabel) heart.setAttribute('aria-label', heartLabel);
  }
  const controlsSelector = '#swym-advanced-header-icon, #swym-storefront-layout-container, .laboosh-card-wishlist, #custom-wishlist-button, [data-product-wishlist]';
  function scheduleAppControls() {
    if (controlsFrame) return;
    controlsFrame = requestAnimationFrame(() => {
      controlsFrame = null;
      localizeAppControls();
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    localizeAppControls();
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node =>
        node instanceof Element && (node.matches(controlsSelector) || node.querySelector(controlsSelector))
      ))) scheduleAppControls();
    }).observe(document.body, { childList: true, subtree: true });
  });

  function message(container, value) {
    let status = container.querySelector('[data-wishlist-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.wishlistStatus = '';
      status.setAttribute('role', 'status');
      status.style.cssText = 'font:inherit;font-size:12px;line-height:1.6;margin:10px 0;white-space:normal;';
      container.append(status);
    }
    status.textContent = value;
  }

  function closePickers() {
    document.querySelectorAll('.wishsize-open').forEach(wrap => {
      wrap.classList.remove('wishsize-open');
      wrap.querySelector('.laboosh-card-wishlist')?.setAttribute('aria-expanded', 'false');
    });
  }

  function openWishlist() {
    localizeWishlist();
    if (window.SwymStorefrontLayoutExtensions?.SwymStorefrontLayout) {
      Object.assign(window.SwymStorefrontLayoutContext.Strings, text.cloud);
      location.hash = window.SwymStorefrontLayoutContext.StorefrontLayoutUrls.List;
      window.SwymStorefrontLayoutExtensions.SwymStorefrontLayout.reRenderStorefrontLayoutUI();
      window.SwymStorefrontLayoutExtensions.refreshWishList();
      window.SwymStorefrontLayoutExtensions.SwymStorefrontLayout.open();
    } else if (window.SwymGhostWishlistDrawer?.isActive()) {
      window.SwymGhostWishlistDrawer.open();
    } else {
      const header = document.querySelector('header-actions');
      if (header) message(header, text.saving);
      if (!pendingOpen) pendingOpen = setTimeout(() => {
        pendingOpen = null;
        if (header) message(header, text.unavailable);
      }, 15000);
      return;
    }
    document.querySelector('header-actions [data-wishlist-status]')?.remove();
  }

  function save(button, variantId, container, size) {
    if (button.disabled) return;
    const product = {
      epi: Number(variantId),
      empi: Number(button.dataset.productId),
      du: button.dataset.productUrl
    };
    if (!product.epi || !product.empi || !product.du) {
      message(container, text.failed);
      return;
    }
    if (!sdk) {
      const local = window.SwymLocalWishlist;
      if (!local?.isGhostIntentActive?.()) {
        message(container, text.unavailable);
        return;
      }
      const applyLocal = () => {
        const du = new URL(product.du, location.origin).pathname;
        const previous = local.getItems().find(item => String(item.empi) === String(product.empi));
        const sameSize = previous && String(previous.epi) === String(product.epi);
        if (previous) local.removeItem(previous);
        const item = { ...product, du, dt: (button.dataset.productTitle + (size ? ' — ' + size : '')).replace(/[&<>"']/g, c => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c])),
          iu: button.dataset.productImage || '', pr: null, stk: button.dataset.available === 'false' ? 0 : 1 };
        if (!sameSize) local.addItem(item);
        const saved = local.getItems().some(item => String(item.epi) === String(product.epi));
        if (saved !== !sameSize) { message(container, text.failed); return; }
        button.classList.toggle('swym-added', saved);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', saved ? text.remove : text.save);
        message(container, (saved ? text.saved : text.removed).replace('[size]', size || ''));
        updateProductWishlistButton();
        if (saved) {
          local.incrementClickCounter();
          if (local.shouldShowSyncNudge() === 'popup') window.SwymConsentPopupManager?.show({
            source: 'ghost-intent-nudge', nudge: true, itemCount: local.getCount(), isFullCapacity: local.getDeclineStage() >= 1
          });
        }
      };
      if (local.requiresLocalStorageConsent()) {
        window.SwymConsentPopupManager?.show({ source: 'laboosh-wishlist', localOnly: true, pendingAction: applyLocal });
      } else if (local.isConsentBlocked()) {
        window.SwymConsentPopupManager?.show({ source: 'ghost-intent-nudge', nudge: true, itemCount: local.getCount(), isFullCapacity: true });
      } else { applyLocal(); }
      return;
    }
    button.disabled = true;
    message(container, text.saving);
    updateProductWishlistButton();
    let finished = false;
    const finish = (saved, value) => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      button.disabled = false;
      if (saved !== null) {
        if (saved) savedVariants.add(String(product.epi));
        else savedVariants.delete(String(product.epi));
        button.classList.toggle('swym-added', saved);
        button.setAttribute('aria-pressed', String(saved));
        button.setAttribute('aria-label', saved ? text.remove : text.save);
      }
      message(container, value);
      updateProductWishlistButton();
    };
    const timeout = setTimeout(() => finish(null, text.failed), 15000);
    const api = window.SwymStorefrontLayoutAPI?.SwymWLAsyncApis;
    if (!api) { finish(null, text.unavailable); return; }
    (async () => {
      const lists = await api.fetchLists();
      if (finished) return;
      const list = lists.find(item => !item.lty) || lists[0] || await api.createList();
      if (finished || !list?.lid) return;
      const items = await api.fetchListProductsDetails(list.lid);
      if (finished) return;
      const exists = items.some(item => String(item.epi) === String(product.epi));
      if (exists) await api.removeProductFromList(product, list.lid);
      else await api.addProductsToList([product], list.lid);
      if (finished) return;
      const updated = await api.fetchListProductsDetails(list.lid);
      const saved = updated.some(item => String(item.epi) === String(product.epi));
      finish(saved === !exists ? saved : null,
        saved === !exists ? (saved ? text.saved : text.removed).replace('[size]', size || '') : text.failed);
    })().catch(() => finish(null, text.failed));
  }

  window.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('[data-ghost-consent-cta]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      localizeWishlist();
      const popup = window.SwymConsentPopupManager;
      if (!popup?.show) {
        message(target.closest('#swym-ghost-wishlist-drawer'), text.unavailable);
        return;
      }
      window.SwymGhostWishlistDrawer?.close();
      popup.show({ source: 'ghost-wishlist-drawer', nudge: true, itemCount: window.SwymLocalWishlist?.getCount() || 0 });
      return;
    }
    if (target.closest('#swym-advanced-header-icon, #swym-advanced-header-icon-mobile')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openWishlist();
      return;
    }
    const cartButton = target.closest('#swym-ghost-wishlist-drawer [data-atc-du], swym-storefront-layout-item [data-action="add-to-cart"]');
    if (cartButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (cartButton.disabled) return;
      const cloudItem = cartButton.closest('swym-storefront-layout-item');
      const variantId = cloudItem?.dataset.epi || cartButton.dataset.atcEpi;
      const root = window.Shopify?.routes?.root || '/';
      if (!variantId) {
        location.assign(cloudItem?.dataset.du || cartButton.dataset.atcDu);
        return;
      }
      cartButton.disabled = true;
      cartButton.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(response => {
        if (!response.ok) throw new Error('Cart add failed');
        location.assign(root + 'cart');
      }).catch(() => {
        cartButton.disabled = false;
        cartButton.removeAttribute('aria-busy');
        message(cloudItem || cartButton.closest('.swym-ghost-wl-item'), text.cartFailed);
      });
      return;
    }
    const sizeButton = target.closest('[data-wishlist-size]');
    const heart = target.closest('.laboosh-card-wishlist, #custom-wishlist-button, [data-product-wishlist]');
    if (!sizeButton && !heart) {
      if (!target.closest('[data-wishlist-sizes]')) closePickers();
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (sizeButton) {
      const wrap = sizeButton.closest('.laboosh-product-card__image-wrap');
      const button = wrap?.querySelector('.laboosh-card-wishlist');
      if (button) {
        button.dataset.variantId = sizeButton.dataset.variantId;
        button.dataset.available = String(!sizeButton.classList.contains('is-soldout'));
        save(button, sizeButton.dataset.variantId, wrap.querySelector('[data-wishlist-sizes]'), sizeButton.dataset.size);
      }
      return;
    }
    const productRoot = heart.closest('.laboosh-product');
    if (productRoot) {
      const button = productRoot.querySelector('#custom-wishlist-button');
      const sizes = productRoot.querySelector('.laboosh-product__sizes');
      const selected = productRoot.querySelector('[data-inline-size].selected');
      if (sizes && !selected) {
        message(sizes, text.choose);
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizes.querySelector('[data-inline-size]')?.focus({ preventScroll: true });
        return;
      }
      button.dataset.available = selected?.dataset.available || 'true';
      save(button, selected?.dataset.variantId || button.dataset.variantId, sizes || productRoot, selected?.dataset.sizeDisplay || '');
      return;
    }
    const wrap = heart.closest('.laboosh-product-card__image-wrap');
    const picker = wrap?.querySelector('[data-wishlist-sizes]');
    if (picker) {
      const wasOpen = wrap.classList.contains('wishsize-open');
      closePickers();
      wrap.classList.toggle('wishsize-open', !wasOpen);
      heart.setAttribute('aria-expanded', String(!wasOpen));
      if (!wasOpen) picker.querySelector('button')?.focus({ preventScroll: true });
    } else if (wrap) {
      save(heart, heart.dataset.variantId, wrap, '');
    }
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closePickers();
  });
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('[data-inline-size]')) scheduleAppControls();
  });
  preserveSyncedSizes();
})();

